import React from "react";
import { Flex, Text, Box } from "@chakra-ui/react";

interface TrendIndicatorProps {
  value: number;
  isPoints?: boolean;
}

const TrendIndicator: React.FC<TrendIndicatorProps> = ({ 
  value, 
  isPoints = false 
}) => {
  const isPositive = value >= 0;
  const color = isPositive ? "green.600" : "red.600";
  const arrowChar = isPositive ? "↑" : "↓";
  const text = `${isPositive ? "Up" : "Down"} by ${Math.abs(value)}${isPoints ? " points" : "%"}`;

  return (
    <Flex 
      position="absolute"
      top="13px"
      right="5"
      color={color}
      alignItems="center"
      fontSize="sm"
      fontWeight="medium"
      zIndex="1"
    >
      <Text>{text}</Text>
      <Box as="span" ml={1} fontSize="lg" fontWeight="bold">
        {arrowChar}
      </Box>
    </Flex>
  );
};

export default TrendIndicator; 